import React from 'react'
import { CFooter } from '@coreui/react-pro'

const AppFooter = () => {
  const currentYear = new Date().getFullYear()

  return (
    <CFooter>
      <div>
        <span className="ms-1">&copy; MyClubtap {currentYear}.</span>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
